"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");
var $               = require("jquery");
var UrlUtil         = require("../../common/utils/url-util");
var AggregationModel= require("./aggregation-model");


Backbone.$          = $;

// QueryModel : query pv5 search engine, this abstract class must be extended
module.exports = Backbone.Model.extend({

    pv5api: null,
    fetched: false,
    fetching:false,
    token:null,

    defaults: {
        query:null,         // query name : must be filled by derived class
        page:0,      // page de résultat actuelle
        pendingPage:0,      // page de résultat actuellement fetched
        pageSize:10,        // nombre de résultats récupérés en une fois
        total:0,            // nombre total de résultats, rempli après une première synchro
        results:null,       // results collection
        aggregations:null,  // aggregations result collection
        sort:null
    },

    initialize: function (attributes, options) {
        var T = this;
        _.extend(T, options);

        /*if (!T.pv5api) {
            throw new Error("You need to define a 'pv5api' property");
        }*/

        T.set(
            {
                results:new Backbone.Collection(),          // results collection
                aggregations:new Backbone.Collection()      // aggregations collection
            }
        );

    },

    // overide sync to call elasticsearch
    sync: function (method, model, options, defaults) {
        var T=this;

        // only read is allowed
        if (method !== "read") {
            throw new Error("method not allowed "+method);
        }

        var data=_.defaults(defaults, {
            size: model.get("pageSize")
        });

        var q={};
        if(_.isFunction(model.buildQuery)){
            q=model.buildQuery();
        }
        data=_.extend(data,q);// build query

        // JSON request options
        var params = {
            type: "POST",
            dataType:"json",
            jsonp: false,
            contentType:"application/json",
            crossDomain:true,
            data:JSON.stringify(data),
            url:model.pv5api+"/search/"+model.get("query")
        };

        // ajout token
        if(T.token){
            if(!params.headers){
                params.headers={};
            }
            params.headers["x-access-token"]=T.token;
        }

        params=_.extend(params, options);
        var xhr=Backbone.ajax(params);
        model.trigger("request", model, xhr, options);
        return xhr;
    },

    // override fetch method to update local collections
    // instead of recreating the model
    fetch: function(defaults, options) {
        //console.log("fetch");
        options = options ? _.clone(options) : {};
        defaults = defaults || {};

        var T = this;
        var success_cb = options.success;
        var error_cb = options.error;

        T.fetching=true;

        options.success = function(res, status, xhr) {
            T.set("page", T.get("pendingPage"));

            T.fetched=true;
            T.fetching=false;

            if(_.isFunction(T.parse)){
                res = T.parse(res, xhr);
            }

            var results = T.parseResults(res, xhr);
            var aggs = T.parseAggregations(res, xhr);

            if (options.add) {
                T.get("results").add(results);
            }
            else {
                T.get("results").reset(results);
                T.get("aggregations").reset(aggs);
            }  

            if (success_cb){
                success_cb(T, res);
            }
            T.trigger("sync", T, res, options);
        };
        options.error = function(xhr){
            T.fetching=false;
            if (error_cb){
                error_cb(T, xhr, options);
            }
            T.trigger("error", T, xhr, options);
        };

        return T.sync("read", T, options, defaults);
    },

    parse: function (response/*, xhr*/) {
        return response;
    },

    parseResults: function (response/*, xhr*/) {

        var res = [];
        var total=0;

        if(response.hits && response.hits.total){
            total=response.hits.total;
        }

        this.set("total", total);
        if (!total) {
            return res;
        }

        response.hits.hits.forEach(function(hit){
            var result=hit.fields;
            result.highlight=hit.highlight;
            result.score=hit.score;
            res.push(result);
        });
        return res;
    },

    parseAggregations:function(response/*, xhr*/){
        var aggs = [];
        if(response.aggregations){
            for(var index in response.aggregations) {
                var agg = response.aggregations[index];
                var aggm = new AggregationModel({name:index,queryModel:this});
                aggm.set("agg",agg);
                aggs.push(aggm);
            }
        }
        return aggs;
    },

    hasNextPage: function () {
        return this.get("page") < this.getTotalPages();
    },

    hasPage: function (page) {
        var ret=true;
        if(page <  1 || page > this.getTotalPages()){
            ret=false;
        }
        return ret;
    },

    getTotalPages: function () {
        return Math.ceil(this.get("total") / this.get("pageSize")) ;
    },

    /**
     * fetch page, reset result from previous query
     * @param  {Number} page    page to retrieve from server, first page is 1
     * @param  {bool} add  add or reset result array
     * @param  {Object} options
     * @return {xhr||false} return false if a fetch is already in progress
     */
    fetchPage:function(page,add,options){
        if(this.fetching){
            return;
        }
        var final_options=options||{};
        final_options.add=add;
        this.set("pendingPage",page);
        return this.fetch({
            "from": (page-1)*this.get("pageSize")
        }, final_options);
    },

    /**
     * fetch next page, add result to previous result collection
     * @param  {Object} options
     * @return {xhr||false} return false if a fetch is already in progress
     */
    fetchNextPage: function (options) {
        return this.fetchPage(this.get("page")+1,true,options);
    },


    /**
     * fetch first page result, reset result collection
     * @param  {[type]} options [description]
     * @return {xhr||false} return false if a fetch is already in progress
     */
    fetchFirstPage:function(options){
        return this.fetchPage(1,false, options);
    },

    /**
     * fetchFirstPage alias
     * @param  {[type]} options [description]
     * @return {xhr||false} return false if a fetch is already in progress
     */
    search:function(options){
        return this.fetchFirstPage(options);
    },

    /**
     * analyse query string and fill model
     * @param {String} queryString [description]
     */
    setQueryString:function(queryString){
        var T=this;

        var objs=UrlUtil.parseQueryString(queryString,T.whiteList);
        _.each(objs,function(value, key){
            var v=T.get(key);
            if(_.isBoolean(v)){
                objs[key]=(value=="true")?true:false;
            }
            else if(_.isNumber(v)){
                objs[key]=parseInt(value,10);
            }
        });
        T.set(objs);
    },

    /**
     * generate query string from model
     * @return {String} allTerms=joseph&someTerms=vendu
     */
    getQueryString:function(){
        var T=this;
        return UrlUtil.generateQueryString(T.toJSON(),T.whiteList);
    },

});